import type { ArticleListProps } from "./ArticleList.d";

export default function ArticleList({ items, columns, showIngress = true }: ArticleListProps) {
  const gridClass = [
    "article-list",
    columns === 4 ? "article-list--4" : "",
    !showIngress ? "article-list--compact" : "",
  ].filter(Boolean).join(" ");

  return (
    <div className={gridClass}>
      {(items ?? []).map(
        (
          { title, description, author, url, image, imageAlt, focalPoint },
          idx,
        ) => {
          const external = !!url?.match(/^https?:/);

          let imgStyle: React.CSSProperties | undefined;
          if (focalPoint?.x != null && focalPoint?.y != null) {
            const x = Math.round(focalPoint.x * 100);
            const y = Math.round(focalPoint.y * 100);
            imgStyle = {
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: `${x}% ${y}%`,
            };
          }

          return (
            <a
              key={idx}
              href={url}
              target={external ? "_blank" : undefined}
              rel={external ? "noreferrer" : undefined}
            >
              <article>
                <figure>
                  <img src={image} alt={imageAlt} style={imgStyle} />
                </figure>
                <div>
                  <h3>{title}</h3>
                  {showIngress && <div>{description}</div>}
                  <footer>{author && `Av: ${author}`}</footer>
                </div>
              </article>
            </a>
          );
        },
      )}
    </div>
  );
}
